<div class="row g-3 mb-3 d-print-none" *ngIf="listData?.length > 0">
	<div class="col-9">
	</div>
	<div class="col-3 text-end">
		<button (click)="onPrint()" class="btn btn-primary" id="btn-print">
			<i class="bi bi-printer"></i> Imprimir
		</button>
	</div>
</div>
<main class="relatorio3">
  <ng-container *ngFor="let data of listData">
    <ng-container *ngFor="let group of data?.stmt1">
      <section>
        <div class="row-fluid text-center capa1">
          <img src="assets/images/logo_RS_G.jpg">
          <p>
            <strong>Governo do Estado Rio Grande do Sul</strong>
          </p>
          <p>
            Pleitos do RS ao <strong>{{ data?.process_name }}</strong>
          </p>
          <br/><br/>
          <p class="titulo-resposta">
            <strong>{{ group.ds_value }}</strong>
          </p>
        </div>
      </section>
      <section>
        <div class="row-fluid">
          <h1 class="text-center">Sumário</h1>
          <div>
            <ul class="font1">
              <li>Apresentação</li>
              <li>Resumo por Secretaria Responsável</li>
              
              <li>
                {{ group.ds_value }}
                <ol>
                  <li *ngFor="let project of group?.ppPreProject">
                    {{ project.title.toUpperCase() }}
                  </li>
                </ol>
              </li>
            </ul>
          </div>
        </div>
      </section>
      <section>
        <div class="row-fluid">
          <h1 class="text-center apresentacao1">Apresentação</h1>
          <p class="font1">{{data?.process_presentation}}</p>
        </div>
      </section>
      <section>
        <ng-container *ngTemplateOutlet="tableValues; context: { data:group } "></ng-container>
      </section>
      <ng-container *ngFor="let linha of group?.ppPreProject4 let i = index">
        <div class="row-fluid avoid-break">
          <h1 class="page-header">
            1. IDENTIFICAÇÃO DO PLEITO
          </h1>
          <ng-container *ngTemplateOutlet="rowItem;
            context: { data:{'label':'1.1 NOME DO PROJETO', 'data': [linha.title | uppercase]} } ">
          </ng-container>
          <ng-container *ngTemplateOutlet="rowItem;
            context: { data:{'label':'1.2 SECRETARIA RESPONSÁVEL', 'data': [linha.agency_name]} } ">
          </ng-container>
          <ng-container *ngTemplateOutlet="rowItem;
            context: { data:{'label':'1.3 ÓRGÃO EXECUTIVO', 'data': linha?.stmtAgency} } ">
          </ng-container>
        </div>
        <div class="row-fluid avoid-break">
          <h2 class="page-subheader">
            2. ESCOPO
          </h2>
          <ng-container *ngTemplateOutlet="rowItem;
            context: { data:{'label':'2.1 OBJETO', 'data': [linha.ds_object]} } ">
          </ng-container>
          <ng-container *ngTemplateOutlet="rowItem;
            context: { data:{'label':'2.2 OBJETIVO', 'data': [linha.ds_objective]} } ">
          </ng-container>
          <ng-container *ngTemplateOutlet="rowItem;
            context: { data:{'label':'2.3 JUSTIFICATIVA', 'data': [linha.ds_reason]} } ">
          </ng-container>
          <ng-container *ngTemplateOutlet="rowItem;
            context: { data:{'label':'2.4 PÚBLICO ALVO', 'data': [linha.ds_target]} } ">
          </ng-container>
          <ng-container *ngTemplateOutlet="rowItem;
            context: { data:{'label':'2.5 LOCALIZAÇÃO DO PROJETO', 'subitens':linha?.execList[linha.local_exec_type], 
                            'data': [getListType(listLocalExecType, linha.local_exec_type, 'Estado')], 'elseData': ['Estado']} } ">
          </ng-container>
          <ng-container *ngTemplateOutlet="rowItem;
            context: { data:{'label':'2.6 ABRANGÊNCIA', 'subitens':linha?.benList[linha.local_ben_type], 
                            'data': [getListType(listLocalBenType, linha.local_ben_type, 'Estado')], 'elseData': ['Estado']} } ">
          </ng-container>
        </div>
        <div class="row-fluid avoid-break">
          <h2 class="page-subheader">
            3. QUALIFICAÇÃO DO ESCOPO
          </h2>
          <ng-container *ngTemplateOutlet="rowItem;
            context: { data:{'label':'3.1 SITUAÇÃO DO PROJETO', 'data': [linha.situation_name]} } ">
          </ng-container>
          <ng-container *ngTemplateOutlet="rowItem;
            context: { data:{'label':'3.2 TEMPO DE EXECUÇÃO (MESES)', 'data': [linha.exec_duration]} } ">
          </ng-container>
        </div>
        <div class="row-fluid avoid-break">
          <h2 class="page-subheader">
            4. CUSTO
          </h2>
          <ng-container *ngTemplateOutlet="rowItem;
            context: { data:{'label':'4.1 MOEDA', 'data': [linha.currency_name]} } ">
          </ng-container>
          <ng-container *ngTemplateOutlet="rowItem;
            context: { data:{'label':'4.2 TOTAL', 'data': [linha.cost_total | number:'1.2-2']} } ">
          </ng-container>
          <ng-container *ngTemplateOutlet="rowItem;
            context: { data:{'label':'4.3 PERCENTUAL DE CONTRAPARTIDA (%)', 'data': [linha.perc_loan | number:'1.2-2']} } ">
          </ng-container>
          <ng-container *ngTemplateOutlet="rowItem;
            context: { data:{'label':'4.4 VALOR DA CONTRAPARTIDA', 'data': [linha.cost_without_loan | number:'1.2-2']} } ">
          </ng-container>
          <ng-container *ngTemplateOutlet="rowItem;
            context: { data:{'label':'4.5 VALOR DA UNIÃO', 'data': [linha.cost_loan | number:'1.2-2']} } ">
          </ng-container>
        </div>

        <div class="row-fluid avoid-break">
          <h2 class="page-subheader">
            5. PRODUTOS
          </h2>
          
          <table class="table font1">
            <thead>
              <tr>
                <th>Produto</th>
                <th><div class="text-center">META (Unidade)</div></th>
                <th><div class="text-center">Custo</div></th>
                <th><div class="text-center">Prazo (meses)</div></th>
              </tr>
            </thead>
            <tbody>
            <tr *ngFor="let item of linha?.stmtProds">
              <td>{{ item.description }}</td>
              <td class="text-center">{{ item.ds_goal | number:'1.2-2' }} ({{item.unit_id}})</td>
              <td class="text-center">{{ item.value| number:'1.2-2' }}</td>
              <td class="text-center">{{ item.exec_duration }}</td>
            </tr>
          </table>
          <ng-container *ngIf="linha?.stmtModProds.length > 0">
            <p class="font1">
              <strong>5.1 REQUISITOS DE EXECUÇÃO</strong>
            </p>
            <table class="table font1">
              <thead>
                <tr>
                  <th>Produto</th>
                  <th><div>Modalidade de execução / aquisição</div></th>
                  <th><div class="text-center">Etapa</div></th>
                  <th><div class="text-center">Status</div></th>
                </tr>
              </thead>
              <tbody>
              <tr *ngFor="let item of linha?.stmtModProds let i = index">
                <td *ngIf="i === 0 || item.description !== linha?.stmtModProds[i - 1]?.description"
                    [attr.rowspan]="item.tot_itens">
                      {{ item.description }}
                </td>
                <td *ngIf="(i === 0 || item.description !== linha?.stmtModProds[i - 1]?.description) ||
                          (i === 0 || item.prod_template_name !== linha?.stmtModProds[i - 1]?.prod_template_name)"
                    [attr.rowspan]="item.tot_itens">
                      {{ item.prod_template_name }}
                </td>
                <td class="text-center">{{ item.step_name }}</td>
                <td class="text-center">{{ item.prod_step_stat_name }}</td>
              </tr>
            </table>
          </ng-container>
        </div>

        <div class="row-fluid avoid-break">
          <h2 class="page-subheader">
            6. CAPACIDADE DE EXECUÇÃO DO PROJETO
          </h2>
          <ng-container *ngTemplateOutlet="rowItem;
            context: { data:{'label':'6.1 EQUIPE DEFINIDA', 'data': [linha.equip_ready == 1 ? 'Sim' : 'Não']} } ">
          </ng-container>
          <ng-container *ngTemplateOutlet="rowItem;
            context: { data:{'label':'6.2 ÓRGÃOS PÚBLICOS ENVOLVIDOS', 'data': [linha.ds_agency]} } ">
          </ng-container>
          <ng-container *ngTemplateOutlet="rowItem;
            context: { data:{'label':'6.3 ORGANIZAÇÕES PARCEIRAS', 'data': [linha.ds_organization]} } ">
          </ng-container>
        </div>

        <div class="row-fluid avoid-break">
          <h2 class="page-subheader">
            7. ALINHAMENTO ESTRATÉGICO
          </h2>
          <ng-container *ngIf="linha?.stmtQuestions.length > 0">
            <ng-container *ngFor="let item of linha?.stmtQuestions let i = index">
              <ng-container *ngTemplateOutlet="rowItem;
                context: { data:{'label': '7.' + (i+1) + ' ' + (item.report_title ?? item.title),
                                'data': isJsonArray(item.ds_value) ? jsonArray : [item.ds_value]} } ">
              </ng-container>
            </ng-container>
          </ng-container>
        </div>
        
        <div class="row-fluid avoid-break">
          <h2 class="page-subheader">
            8. INFORMAÇÕES ADICIONAIS
          </h2>
          <ng-container *ngTemplateOutlet="rowItem;
            context: { data:{'label':'8.1 NOME DO RESPONSÁVEL', 'data': [linha.resp_nome]} } ">
          </ng-container>
          <ng-container *ngTemplateOutlet="rowItem;
            context: { data:{'label':'8.2 TELEFONE DO RESPONSÁVEL', 'data': [(linha.resp_ddd ?'(' + linha.resp_ddd + ') ' : '') + (linha.resp_tel ?? '') ]} } ">
          </ng-container>
          <ng-container *ngTemplateOutlet="rowItem;
            context: { data:{'label':'8.3 E-MAIL DO RESPONSÁVEL', 'data': [linha.resp_email]} } ">
          </ng-container>
        </div>
      </ng-container>
    </ng-container>
  </ng-container>
</main>
<ng-template #tableValues let-data="data">
  <div class="row-fluid">
    <h1 class="text-center resumo1">
      Resumo por Secretaria Responsável
    </h1>
    <table class="table font1">
      <thead>
        <tr>
          <th><div class="text-center">Órgão</div></th>
          <th><div class="text-right">Nº Pleitos</div></th>
          <th><div class="text-right">Contrapartida (R$)</div></th>
          <th><div class="text-right">União (R$)</div></th>
        </tr>
      </thead>
      <tbody>
      <tr *ngFor="let item of data?.ppPreProject3">
        <td>{{ item.ds_value || (item.agency_name || 'NI') }}</td>
        <td class="text-right">{{ item.tot_pleitos }}</td>
        <td class="text-right">{{ item.tot_cost_without_loan| number:'1.2-2' }}</td>
        <td class="text-right">{{ item.tot_cost_loan| number:'1.2-2' }}</td>
      </tr>
      <tr *ngIf="sumTotals(data?.ppPreProject3) as total">
        <td>Totais</td>
        <td class="text-right">{{ total.tot_pleitos }}</td>
        <td class="text-right">{{ total.tot_cost_without_loan | number:'1.2-2' }}</td>
        <td class="text-right">{{ total.tot_cost_loan | number:'1.2-2' }}</td>
      </tr>
    </table>
  </div>
</ng-template>
<ng-template #rowItem let-data="data">
  <div class="row-fluid" *ngIf="data.data || data.elseData">
    <p class="font1">
      <strong>{{data.label}}</strong>
    </p>
    <ng-container *ngIf="data.data?.length > 1; else elseSubItem">
      <ul class="font1">
        <li *ngFor="let item of data.data">
          {{item}}
        </li>
      </ul>
    </ng-container>
    <ng-template #elseSubItem>
      <ng-container *ngIf="data.data?.length > 0; else elseItem">
        <p class="font1" *ngFor="let item of data.data">
          {{ item }}
        </p>
        <ng-content *ngTemplateOutlet="listItem;
          context: { data:data?.subitens} ">
        </ng-content>
      </ng-container>
    </ng-template>
    <ng-template #elseItem>
      <p class="font1" *ngFor="let item of data.elseData">
        {{item ?? ''}}
      </p>
    </ng-template>
  </div>
</ng-template>
<ng-template  #listItem let-data="data">
  <ul *ngIf="data?.length > 0">
    <li class="font1" *ngFor="let item of data">
      {{ item.label }}
    </li>
  </ul>
</ng-template>
<app-loading [loader]="isLoading"></app-loading>
